import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
// import AddArticle from '../DiscoverNew/Components/AddArticle';
import Discover from "../DiscoverNew";
import Landing from "../Landing";
import userStore from "../../Stores/User";
import queryString from "query-string";
import loading from "../../Assets/loading.gif";

const ContentSwitch = observer(({ history }) => {
  const pathname = history.location.pathname;
  const USER_ID = queryString.parse(history.location.search).USER_ID;

  useEffect(() => {
    console.log("userStore.isSignedIn", userStore.isSignedIn)
    if (userStore.isSignedIn) {
      // Use matchMedia instead of direct window.innerWidth check
      const isMobileView = window.matchMedia("(max-width: 1199.98px)").matches;
      // Change the CSS .intercom-lightweight-app-launcher bottom
      if (isMobileView) {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
      } else {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
      }
      
      // Add listener for screen size changes
      const mediaQueryList = window.matchMedia("(max-width: 1199.98px)");
      const handleMediaChange = (e) => {
        if (e.matches) {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
        } else {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
        }
      };
      
      mediaQueryList.addEventListener('change', handleMediaChange);
      
      return () => {
        mediaQueryList.removeEventListener('change', handleMediaChange);
      };
    } else {
      document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
    }
  }, [userStore.isSignedIn])

  if (userStore.isSignedIn === true) {
    return <Discover />;
  }

  if (userStore.isSignedIn === false) {
    if (pathname !== "/") {
      // If it's not "/", i.e. "/add" "/playlist" etc, send them to
      // Signin instaed of the landing page.
      if (USER_ID) {
        // HACK: unlogged in iOS users w/ legacy USER_ID param
        // gets redirected to /signin/user_id to send merge request to backend
        return <Redirect to={`/signin/${USER_ID}`} />;
      } else {
        return <Redirect to="/signin" />;
      }
    } else {
      return <Landing />;
    }
  }

  return (
    <div className="center">
      <img src={loading} style={{height: '50px'}}/>
    </div>
  );
});

export default ContentSwitch;
